



































































import { Component, Vue } from 'vue-property-decorator'
import debounce from 'lodash/debounce'
import StaffEditor from './components/StaffEditor.vue'
import { MemberController, AdminMemberController } from '@/services/request.service'
import { getRoleType, getLocale } from '@/utils/utils'

@Component({
  components: {
    StaffEditor,
  },
})
export default class StaffMgmt extends Vue {
  private loading = false
  private data: any = []
  private filters = {
    name: '',
  }
  private pagination: any = {
    current: 1,
    defaultCurrent: 1,
    defaultPageSize: 20,
    pageSizeOptions: ['10', '20', '50'],
    showQuickJumper: true,
    showSizeChanger: true,
    showTotal: total => this.totalText(total),
  }
  private total = 0
  private addVisible = false
  private editVisible = false
  private staff: any = {
    email: '',
    name: '',
    enName: '',
    roleId: undefined,
  }
  private memberId = 0

  private get roleType(): string {
    return getRoleType()
  }

  private get locale(): string {
    return getLocale()
  }

  private get columns(): any {
    return [
      {
        title: this.$tc('common.name'),
        scopedSlots: {
          customRender: 'name',
        },
      },
      {
        title: this.$tc('staffMgmt.role'),
        dataIndex: this.locale === 'zh' ? 'roleName' : 'roleEnName',
      },
      {
        title: this.$tc('staffMgmt.account'),
        dataIndex: 'email',
      },
      {
        title: this.$tc('common.operations'),
        scopedSlots: {
          customRender: 'operations',
        },
      },
    ]
  }

  private created(): void {
    this.getStaffs()
  }

  private totalText(total): string {
    return this.$tc('staffMgmt.staffTotal', total, { total })
  }

  private changeFilter = debounce(() => {
    this.getStaffs()
  }, 1000)

  private getStaffs(page = {}): void {
    this.loading = true
    const { name } = this.filters
    const request = {
      pageCurrent: 1,
      pageSize: 20,
      name: name.trim() || undefined,
      memberType: '1002',
      ...page,
    }
    AdminMemberController.getPageList(request)
      .then(res => {
        this.data = res.data.items
        this.$set(this.pagination, 'total', res.data.totalItem)
        this.total = res.data.totalItem
      })
      .catch(err => {
        console.error(err)
      })
      .finally(() => {
        this.loading = false
      })
  }

  private handleTableChange(pagination): void {
    let pager = { ...this.pagination }
    pager.current = pagination.current
    this.pagination = pager
    this.getStaffs()
  }

  private add(): void {
    this.addVisible = true
  }

  private edit(staffId): void {
    this.editVisible = true
    AdminMemberController.detail(staffId)
      .then(res => {
        this.staff = {
          email: res.data.email,
          name: res.data.name,
          enName: res.data.enName,
          roleId: res.data.role.roleId,
        }
      })
      .catch(err => {
        console.error(err)
      })
    this.memberId = staffId
  }

  private cancel(): void {
    if (this.memberId) {
      this.editVisible = false
      this.memberId = 0
    } else {
      this.addVisible = false
    }
    this.staff = {
      email: '',
      name: '',
      enName: '',
      roleId: undefined,
    }
  }

  private saveStaff(): void {
    const { email, name, enName, roleId } = this.staff
    const request = {
      memberId: this.memberId || undefined,
      email,
      name,
      enName,
      roleId,
      memberType: '1002',
    }
    if (this.memberId) {
      AdminMemberController.update(request)
        .then(res => {
          this.editVisible = false
          this.memberId = 0
          this.$message.success(this.$tc('common.saveSuccess'))
          this.getStaffs()
        })
        .catch(err => {
          console.error(err)
        })
    } else {
      AdminMemberController.add(request)
        .then(res => {
          this.addVisible = false
          this.memberId = 0
          this.$message.success(this.$tc('common.saveSuccess'))
          this.getStaffs()
        })
        .catch(err => {
          console.error(err)
        })
    }
  }

  private deleteRecord(staffId): void {
    AdminMemberController.delete(staffId)
      .then(res => {
        this.$message.success(this.$tc('common.deleteSuccess'))
        this.getStaffs()
      })
      .catch(err => {
        console.error(err)
      })
  }

  private resetPassword(account, staffId): void {
    this.$confirm({
      title: this.$t('staffMgmt.confirmResetPassword') as string,
      content: h => {
        return h(
          'div',
          {
            style: {
              display: 'flex',
              flexDirection: 'column',
            },
          },
          [
            h('span', this.$t('personal.account') + ': ' + account),
            h('span', this.$t('personal.password') + ': school800'),
          ]
        )
      },
      onOk: () => {
        AdminMemberController.resetPassword(staffId)
          .then(res => {
            this.$message.success(this.$tc('common.resetSuccess'))
          })
          .catch(err => {
            console.error(err)
          })
      },
    })
  }
}
